module.exports = __webpack_public_path__ + "static/mike-martin-law-logo-2x-5b857ae1ca54fd6c052b20ccabfe9107.png";